import { HarvestTimeEntry } from "~/types"
import { HarvestEntry } from "./HarvestEntry"
import "./HarvestGroup.scss"
import classNames from "classnames"

const groupByTask = (entries: HarvestTimeEntry[]) => {
  return Object.groupBy(entries, (entry) => entry.task)
}

type Props = {
  entries: HarvestTimeEntry[]
  onUpdated: () => void
}

export function HarvestGroup({ entries, onUpdated }: Props) {
  if (entries.length === 0) return null

  const groupedEntries = Object.entries(groupByTask(entries))
  const firstEntry = entries[0]

  return (
    <div className="HarvestGroup">
      <div className="HarvestGroup__heading">
        <div className="HarvestGroup__heading-inner">
          <p className="HarvestGroup__client">{firstEntry.client}</p>
          <p className="HarvestGroup__project">{firstEntry.project}</p>
        </div>
      </div>

      <div className="HarvestGroup__task-group">
        {groupedEntries.map(([task, groupEntries], index) => (
          <div key={task}>
            <p
              className={classNames("HarvestGroup__task", {
                "HarvestGroup__task--last": index === groupedEntries.length - 1,
              })}
            >
              {task}
            </p>
            <div
              className={classNames("HarvestGroup__entries", {
                "HarvestGroup__entries--last":
                  index === groupedEntries.length - 1,
              })}
            >
              {groupEntries!.map((entry) => (
                <HarvestEntry
                  key={entry.id}
                  entry={entry}
                  onUpdated={onUpdated}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
